<div class="balance-charges-toolbar" data-balance-charges-toolbar>
  <button
    mat-stroked-button
    type="button"
    [matMenuTriggerFor]="resetMenu"
    data-balance-charges-reset-trigger
  >
    <mat-icon>restart_alt</mat-icon>
    <span>{{ 'common.reset' | translate }}</span>
  </button>

  <button
    *ngIf="templatesEnabled && templateMenu"
    mat-stroked-button
    type="button"
    #templateTrigger="matMenuTrigger"
    [matMenuTriggerFor]="templateMenu"
    class="ml-1"
    data-balance-charges-templates-trigger
  >
    <mat-icon>library_books</mat-icon>
    <span>{{ 'common.template' | translate }}</span>
  </button>

  <button
    mat-flat-button
    color="primary"
    type="button"
    class="ml-1"
    data-balance-charges-calculate
    [disabled]="!canCalculate || busy"
    (click)="onCalculate()"
  >
    <mat-icon>calculate</mat-icon>
    <span>{{ 'balance.charges.calculate-button' | translate }}</span>
  </button>
</div>

<mat-menu #resetMenu="matMenu">
  <button
    *ngIf="canResetByTemplate"
    mat-menu-item
    type="button"
    (click)="onReset('template')"
    data-balance-charges-reset-template>
    {{ 'balance.charges.reset.by-template' | translate }}
  </button>
  <button
    *ngIf="canResetByEstimate"
    mat-menu-item
    type="button"
    (click)="onReset('estimate')"
    data-balance-charges-reset-estimate>
    {{ 'balance.charges.reset.by-estimate' | translate }}
  </button>
  <button
    mat-menu-item
    type="button"
    color="warn"
    (click)="onReset('clear')"
    data-balance-charges-reset-clear>
    <mat-icon color="warn">clear</mat-icon>
    {{ 'balance.charges.reset.all' | translate }}
  </button>
</mat-menu>
